import { obj } from './utils.js';

export default {
    implode(value, glue = ', ', key = 'label|title|key') {
        return (value || []).map(i => obj.get(i, key)).join(glue);
    }
}
